module.exports = __webpack_public_path__ + "static/media/evcharger.bbeebc52.png";